import { getInputElement, event } from './common'

function bind(el, binding, vnode) {
  const inputEL = getInputElement(el)
  inputEL.oninput = function (evt) {
    if (!evt.isTrusted) return // avoid infinite loop

    inputEL.value = inputEL.value.toUpperCase()
    inputEL.dispatchEvent(event('input'))
  }
}

export default {
  name: 'uppercase',
  bind,
  twoWay: true
}
